export default "__VITE_ASSET__Bpjnu$og__"